import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  QueryReturnValue
} from '@reduxjs/toolkit/query';
import { isDate, differenceInMilliseconds } from 'date-fns';

export type QRes = QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>;

export type baseQueryType = BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  object,
  FetchBaseQueryMeta
>;
export type EndpointFailure = {
  count: number;
  lastFailureTimeStamp?: string;
};

export interface ResiliencyState {
  totalFailures: number;
  failures: {
    [key: string]: EndpointFailure;
  };
}

export const timeSinceLastResiliencyFailure = (item: EndpointFailure) => {
  if (!item?.lastFailureTimeStamp) return 0;

  const date = new Date(item?.lastFailureTimeStamp);

  if (!isDate(date)) return 0;

  const now = new Date();
  return differenceInMilliseconds(now, date);
};
